import { render, staticRenderFns } from "./Compositor.vue?vue&type=template&id=a48a7bb6&scoped=true&"
import script from "./Compositor.vue?vue&type=script&lang=js&"
export * from "./Compositor.vue?vue&type=script&lang=js&"
import style0 from "./Compositor.vue?vue&type=style&index=0&id=a48a7bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48a7bb6",
  null
  
)

export default component.exports